import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAddDevicesToGroupMutation } from '../../redux/admin/groupApi';
import './AdminGroupStyles.css';

export default function AddDevices() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [deviceIds, setDeviceIds] = useState('');
  const [addDevices] = useAddDevicesToGroupMutation();

  const submit = async () => {
    if (!deviceIds.trim()) return;
    await addDevices({
      groupId: id,
      deviceIds: deviceIds.split(',').map(s => s.trim()).filter(s => s !== ''),
    });
    navigate(`/groups/${id}`);
  };

  return (
    <div className="gps-dashboard-container">
      <h3>📥 Bulk Add Devices</h3>
      <p style={{ marginBottom: 16, fontSize: '0.9rem', color: '#64748b' }}>
        Paste multiple Device IDs separated by <b>commas</b>.
      </p>
      <textarea
        className="form-control"
        placeholder="64f1..., 64f2..., 64f3..."
        value={deviceIds}
        onChange={(e) => setDeviceIds(e.target.value)}
      />
      <div className="action-row" style={{ marginTop: 20 }}>
        <button className="btn btn-primary" onClick={submit}>Add Devices</button>
        <button className="btn btn-secondary" onClick={() => navigate(`/groups/${id}`)}>Cancel</button>
      </div>
    </div>
  );
}